/**
 * Pantograph
 * has two contacts, each are highlighted according to bits
 * - used in Charleroi
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class PantoAB extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'contactB',
        x: 20,
        y: 0,
        width: 15,
        height: 15,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Rect({
        name: 'contactA',
        x: 0,
        y: 0,
        width: 15,
        height: 15,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      })
    )
  }

  setContact (status, contact) {
    if (status[contact] === 1) {
      this.modifyShape(contact, 'opacity', 0.8)
      this.modifyShape(contact, 'fill', Color.tYellow)
    } else {
      this.modifyShape(contact, 'opacity', 0.3)
      this.modifyShape(contact, 'fill', Color.tBlue)
    }
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(status)

    this.setContact(status, 'contactA')
    this.setContact(status, 'contactB')

    if (status.sequenceError === 1) {
      this.modifyShape('contactA', 'opacity', 0.8)
      this.modifyShape('contactB', 'opacity', 0.8)
      this.modifyShape('contactA', 'fill', 'red')
      this.modifyShape('contactB', 'fill', 'red')
    } else if (status.sequenceError === 0 && status.contactA !== 1) {
      this.modifyShape('contactA', 'fill', Color.tBlue)
      this.modifyShape('contactA', 'opacity', 0.3)
    } else if (status.sequenceError === 0 && status.contactB !== 1) {
      this.modifyShape('contactB', 'fill', Color.tBlue)
      this.modifyShape('contactB', 'opacity', 0.3)
    }
  }
}
